import { AnyAction } from 'redux';

interface IManager {
    loading: boolean;
}

const initialState: IManager = {
    loading: false,
};
export const CreateManager = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case 'LOADING_MANAGER':
            return {
                ...state,
                loading: action.payload,
            };
        default:
            return state;
    }
};
